import React, { useState, useContext, useEffect, useRef } from 'react';
import { Dimensions, View, ActivityIndicator, StyleSheet } from 'react-native-web';

import { fontColorWhite } from '../../../style/css/CmnStyle';
import { hpContext } from '../../hp/HPContext';
const windowWidth = Dimensions.get('window').width;
const windowHeight = Dimensions.get('window').height;

function Loading(props) {
  const isLoading = useContext(hpContext).isLoading;

  return (
    <>
      {isLoading &&
        <View style={styles.container}>
          <ActivityIndicator
            color={fontColorWhite}
            size='large'
          />
        </View>
      }
    </>
  );
}

const styles = StyleSheet.create({
  container: {
    flex: 1,
    alignItems: 'center',
    justifyContent: 'center',
    position: 'fixed',
    top: 0,
    left: 0,
    width: windowWidth,
    height: windowHeight,
    backgroundColor: 'rgba(0, 0, 0, 0.8)',
    zIndex: 100,
  },
});

export default Loading;